import { useQuery } from "@tanstack/react-query";

import { ENDPOINTS } from "@/api/application-api";
import { useAuth } from "@/context/auth-context";
import { useActiveOrganization } from "@/hooks/organizations";
import { OrganizationSubscriptionResponse } from "@/types/organization-usage";
import { handleResponse } from "@/utils/errorResponseHandlers";
import { jsonAuthHeaders } from "@/utils/headers";

export const useOrganizationSubscription = (organizationId?: number) => {
  const userToken = useAuth()?.userToken ?? "";
  const { data: activeOrganization } = useActiveOrganization();
  const activeOrganizationId = activeOrganization?.id;

  return useQuery(
    ["organization_subscription", organizationId],
    (): Promise<OrganizationSubscriptionResponse> => {
      const url = ENDPOINTS.organization_subscription(organizationId || activeOrganizationId!);
      return fetch(url, {
        method: "GET",
        headers: jsonAuthHeaders(userToken),
      }).then(handleResponse);
    },
    {
      enabled: !!(organizationId || activeOrganizationId),
      retry: false,
    },
  );
};
